import { initI18n } from 'www/utils'
import { MOUNT_SELECTOR } from 'www/vue_components/common/BannerMtLink/constants'
import I18NextVue from 'i18next-vue'

const mountElements = [...document.querySelectorAll(MOUNT_SELECTOR)]

async function init() {
  const { i18next } = await initI18n({ bundle: 'vue_components/common/BannerMtLink' })
  const { default: Vue } = await import(/* webpackMode: "eager" */'www/vue_components')
  const { default: vuetify } = await import(/* webpackMode: "eager" */'www/modules/vuetify-plugin')
  const { default: BannerMtLink } = await import(/* webpackMode: "eager" */'www/vue_components/common/BannerMtLink/components/common/BannerMtLink.vue')

  Vue.use(I18NextVue, { i18next })

  // Создаётся один инстанс модалки на десктопе, который будет использоваться всеми баннерами
  if (!window.MOBILE_VERSION) {
    const { initPopupContent } = await import(/* webpackMode: "eager" */'www/vue_components/common/BannerMtLink/functions')

    initPopupContent()
  }

  mountElements.forEach(el => {
    new Vue({
      vuetify,
      el,
      components: {
        BannerMtLink,
      },
    })
  })
}

if (mountElements.length) {
  init()
}
